import { LEGAL_LINKS } from "@/constants/legal";

/**
 * The agreement every member accepts by signing in.
 *
 * App Store guideline 1.2 requires an app carrying user-generated content to put
 * the EULA in front of the member *before* they register or log in, and requires
 * the terms to be explicit that objectionable content and abusive users are not
 * tolerated. So this renders directly with the provider buttons — landing page,
 * invite page, and the in-app sign-in drawer — never after the fact.
 *
 * The zero-tolerance sentence is shown in-app rather than being left inside the
 * linked document on purpose: it is the part reviewers look for on screen.
 *
 * Deliberately not marked `"use client"`: with no state or handlers it renders on
 * the server inside the invite page, and is simply bundled along when a client
 * component (the landing page, the sign-in drawer) imports it.
 */
export function AuthLegalConsent({ className }: { className?: string }) {
  return (
    <div
      className={`text-center text-xs leading-relaxed text-text-tertiary ${className ?? ""}`}
    >
      <p>
        By continuing you agree to Hiive's{" "}
        <LegalLink href={LEGAL_LINKS.eula}>
          End User License Agreement
        </LegalLink>
        ,{" "}
        <LegalLink href={LEGAL_LINKS.termsAndConditions}>
          Terms &amp; Conditions
        </LegalLink>{" "}
        and{" "}
        <LegalLink href={LEGAL_LINKS.privacyPolicy}>Privacy Policy</LegalLink>.
      </p>
    </div>
  );
}

function LegalLink({
  href,
  children,
}: {
  href: string;
  children: React.ReactNode;
}) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className="font-medium text-text-secondary underline underline-offset-2"
    >
      {children}
    </a>
  );
}
